import React, { useState, useMemo, useCallback } from "react"

import GradeHeader from "./components/GradeHeader"
import GradeGrid from "./components/GradeGrid"
import AttendanceModal from "./components/AttendanceModal"

import NeoLoader from "../../components/Common/NeoLoader"
import { NeoCard, Breadcrumb } from "../../components/Common"
import { useGradeData } from "./hooks/useGradeData"
import { getStartOfWeek } from "../../utils/date"

const Grade = () => {

  const [referenceDate, setReferenceDate] = useState(new Date())
  const [view, setView] = useState(() => window.innerWidth < 768 ? "day" : "week")
  const [turn, setTurn] = useState("all")

  const { sessions, loading: loadingData, refresh } = useGradeData({ referenceDate, view })

  const weekStart = useMemo(() => getStartOfWeek(referenceDate), [referenceDate])

  const [selectedScheduleId, setSelectedScheduleId] = useState(null)
  const [selectedScheduleKey, setSelectedScheduleKey] = useState(null)

  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false)
  const [activeAttendanceSchedule, setActiveAttendanceSchedule] = useState(null)

  const handleSelectSchedule = useCallback((schedule, iso) => {
    const id = String(schedule?.id || "")
    if (!id) return
    const key = iso ? `${id}|${iso}` : id

    setSelectedScheduleId(id)
    setSelectedScheduleKey(key)

    setActiveAttendanceSchedule(schedule)
    setIsAttendanceOpen(true)
  }, [])

  if (loadingData) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <NeoLoader type="inline" loading={loadingData} />
      </div>
    )
  }

  return (
    <div
      className="h-100 w-100 pb-5"
      onClick={() => {
        setSelectedScheduleId(null);
        setSelectedScheduleKey(null);
      }}
    >
      <div className="mb-3">
        <Breadcrumb title="Grade de Aulas" />
      </div>

      <div onClick={(e) => e.stopPropagation()}>
        <NeoCard className="mb-4 neo-stat-card" bodyClassName="py-3 px-4">
          <GradeHeader
            turn={turn}
            onTurnChange={setTurn}
            view={view}
            onViewChange={setView}
            referenceDate={referenceDate}
            onReferenceDateChange={setReferenceDate}
          />
        </NeoCard>
      </div>

      {!loadingData && sessions.length === 0 && (
        <div className="alert alert-info mb-3">
          <i className="mdi mdi-information me-2"></i>
          <strong>Nenhuma sessão encontrada.</strong>
          <p className="mb-0 mt-2">
            Cadastre turmas no módulo Gerencial → Turmas para que as sessões apareçam automaticamente na grade.
          </p>
        </div>
      )}

      <GradeGrid
        turn={turn}
        view={view}
        referenceDate={referenceDate}
        weekStart={weekStart}
        schedules={sessions}
        onSelectSchedule={handleSelectSchedule}
        selectedScheduleId={selectedScheduleId}
        selectedScheduleKey={selectedScheduleKey}
      />

      <AttendanceModal
        isOpen={isAttendanceOpen}
        onClose={() => setIsAttendanceOpen(false)}
        schedule={activeAttendanceSchedule}
        onAttendanceSaved={refresh}
      />
    </div>
  )
}

export default Grade
